import { EligibilityHouseholdIncomeScreen } from "@/interactors/EligibilityHouseholdIncomeScreen";

export default function HouseholdIncome() {
  return <EligibilityHouseholdIncomeScreen />;
}
